'use client'

import DtvFooter from "@directv-digital/dds.ui.dtv-footer";

export default function GlobalFooter(props){
  return <DtvFooter {...props}/>
}
